module.exports = __webpack_public_path__ + "static/media/button-close.85bb5c19.svg";